
import { print } from './Logger'

export default class ErrorManager {

	getErrorString(resp) {
		if (!resp) { 
			return "Sorry, something went wrong. We're looking into it. Try again later."
		}

		if (resp.code === -1) { 
			const error = resp.error
			if (error.detail !== undefined) { 
				return error.detail
			}
		
			try { 
				const firstError = error[0]
				const fieldName = Object.keys(firstError)[0]
				const errorMessage = firstError[fieldName][0]
				return `${fieldName}: ${errorMessage}`
			} 
			catch (e) { 
				return "Sorry, something went wrong. We're looking into it. Try again later."
			}
		}

		return null
	}

	getErrorStringOrDefault(resp, str){
		const error = this.getErrorString(resp)
		if (error === null) { 
			return str
		} else { 
			return error
		}
	}
}